import { inject } from 'vue'

export function useFormatDate() {
  const activeLang = inject('activeLang', null)

  function fmtDate(d, options) {
    if (!d) return '—'
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return String(d)
    return options
      ? date.toLocaleString(activeLang?.value ?? undefined, options)
      : date.toLocaleString(activeLang?.value ?? undefined)
  }

  function fmtDateShort(d, options) {
    if (!d) return '—'
    const date = new Date(d)
    if (Number.isNaN(date.getTime())) return String(d)
    return options
      ? date.toLocaleDateString(activeLang?.value ?? undefined, options)
      : date.toLocaleDateString(activeLang?.value ?? undefined)
  }

  return { fmtDate, fmtDateShort }
}
